import { styled, alpha } from '@mui/material/styles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';

export const StyledTreeItem = styled(TreeItem)(({ theme }) => ({
    [`& .${treeItemClasses.groupTransition}`]: {
        marginLeft: 15,
        paddingLeft: 18,
        borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    [`& .${treeItemClasses.iconContainer}`]: {
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.dark,
        ...theme.applyStyles('light', {
            backgroundColor: alpha(theme.palette.primary.main, 0.25),
        }),
        ...theme.applyStyles('dark', {
            color: theme.palette.primary.contrastText
        })
    
    }
}));
